import script from "./PortfolioNew.vue?vue&type=script&setup=true&lang=js"
export * from "./PortfolioNew.vue?vue&type=script&setup=true&lang=js"

import "./PortfolioNew.vue?vue&type=style&index=0&id=add8c21c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-add8c21c"]])

export default __exports__